import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import web3 from "web3";
import { useWeb3React } from "@web3-react/core";
import ReCAPTCHA from "react-google-recaptcha";

import { injected, walletconnect } from "../components/connectors";
import BuyGeosModal from "../components/buyGeosModal";
import Countdown from "../components/countdown";
import DownloadsModal from "../components/downloadsModal";
import Header from "../components/header";
import Footer from "../components/footer";
import Layout from "../components/layout";

import { formattedWallet } from "../utils/account";
import { toFormattedGeoTokensAmount } from "../utils/amount";

import { FaWallet } from "react-icons/fa";

import {
  GEOS_CONTRACT,
  FARMING_CONTRACT,
  VESTING_CONTRACT,
} from "../Constants.js";

import "./styles.css";

const { REACT_APP_SITE_KEY_CAPTCHA } = process.env;

function Vesting() {
  const { active, account, library, activate, deactivate } = useWeb3React();

  // const [tgeTime, setTgeTime] = useState(1639580160);
  const [nClaimTime, setNClaimTime] = useState(0);

  const [shouldPoll, setShouldPoll] = useState(true);
  const [tokenAddress, setTokenAddress] = useState(
    "0xf1428850f92B87e629c6f3A3B75BffBC496F7Ba6"
  );
  const [totalVestment, setTotalVestment] = useState(0);
  const [claimable, setClaimable] = useState(0);

  const captcha = useRef(null);
  const [captchaValidated, setCaptchaValidated] = useState(false);

  const [geoTokensAmount, setGeoTokensAmount] = useState("-");
  const [NFTsAmount, setNFTsAmount] = useState("-");
  const [geoSpinsAmount, setGeoSpinsAmount] = useState("-");
  const [displayBuyGEOTokens, setDisplayBuyGEOTokens] = useState(false);
  const [displayDownloads, setDisplayDownloads] = useState(false);

  useEffect(() => {
    if (shouldPoll) {
      initUIProps();
      initHeaderData();
    }
  }, [active, shouldPoll]);

  function initUIProps() {
    if (active) {
      console.log("Updating");
      getNextClaimTime();
      getTotalVestment();
      getClaimable();
      setShouldPoll(false);
    }
  }

  const initHeaderData = () => {
    if (active) {
      getGeoTokensAmount();
      getNFTsAmount();
      // getGeoSpinsAmount();
    }
  };

  async function connectInjected() {
    try {
      await activate(injected);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function connectWalletConnect() {
    try {
      await activate(walletconnect);
    } catch (ex) {
      console.log(ex);
    }
  }

  async function disconnect() {
    try {
      deactivate();
    } catch (ex) {
      console.log(ex);
    }
  }

  function connectMapper(conn_type) {
    if (!active) {
      switch (conn_type) {
        case "MetaMask":
          return connectInjected();
        case "Wallet Connect":
          return connectWalletConnect();
        case "Trust Wallet":
          return connectInjected();
      }
    }
  }

  async function claimVested() {
    const contract = new library.eth.Contract(
      VESTING_CONTRACT.abi,
      VESTING_CONTRACT.address
    );

    await contract.methods
      .getReturnFromVesting()
      .send({ from: web3.utils.toChecksumAddress(account) })
      .then((res) => {
        if (res) {
          setShouldPoll(true);
          alert(
            "Your Geo$ are on the way! \n\nCongrats on your round of vesting!"
          );
        }
      })
      .catch((err) => console.log(err));
  }

  async function getNextClaimTime() {
    const contract = new library.eth.Contract(
      VESTING_CONTRACT.abi,
      VESTING_CONTRACT.address
    );

    await contract.methods
      .getVestingSchedule(web3.utils.toChecksumAddress(account))
      .call()
      .then((res) => {
        if (res["timestamps"].length > 0) {
          var _nextTs =
            parseInt(res["timestamps"][0]) * 1000 < new Date().getTime()
              ? new Date().getTime() / 1000
              : parseInt(res["timestamps"][0]);
          console.log("ts not zero");
          console.log(_nextTs);
          for (var i = 0; i < res["timestamps"].length; i++) {
            if (parseInt(res["timestamps"][i]) >= _nextTs) {
              setNClaimTime(res["timestamps"][i]);
              break;
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }

  function truncate(str, n) {
    return str.length > n ? str.substr(0, n - 1) : str;
  }

  async function getTotalVestment() {
    const contract = new library.eth.Contract(
      VESTING_CONTRACT.abi,
      VESTING_CONTRACT.address
    );

    await contract.methods
      .getTotalVesting(web3.utils.toChecksumAddress(account))
      .call()
      .then((res) => {
        if (res) {
          setTotalVestment(truncate(web3.utils.fromWei(res, "ether"), 12));
        }
      })
      .catch((err) => console.log(err));
  }

  async function getClaimable() {
    const contract = new library.eth.Contract(
      VESTING_CONTRACT.abi,
      VESTING_CONTRACT.address
    );

    await contract.methods
      .checkWithdrawAmount(web3.utils.toChecksumAddress(account))
      .call()
      .then((res) => {
        if (res) {
          setClaimable(truncate(web3.utils.fromWei(res["0"], "ether"), 12));
        }
      })
      .catch((err) => console.log(err));
  }

  const ConnectedWallet = () => {
    if (active) {
      return formattedWallet(account);
    }
  };

  const getGeoTokensAmount = async () => {
    const contract = new library.eth.Contract(
      GEOS_CONTRACT.abi,
      GEOS_CONTRACT.address
    );

    try {
      await contract.methods
        .balanceOf(web3.utils.toChecksumAddress(account))
        .call()
        .then((res) => {
          const amount = web3.utils.fromWei(res, "ether");
          setGeoTokensAmount(toFormattedGeoTokensAmount(amount));
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const getNFTsAmount = async () => {
    const contract = new library.eth.Contract(
      FARMING_CONTRACT.abi,
      FARMING_CONTRACT.address
    );

    try {
      const NFTs = await contract.methods
        .getWalletNFTs(library.utils.toChecksumAddress(account))
        .call();
      setNFTsAmount(NFTs.length);
    } catch (err) {
      console.log(err);
    }
  };

  // const getGeoSpinsAmount = async () => {
  //   const contract = new library.eth.Contract(
  //     FARMING_CONTRACT.abi,
  //     FARMING_CONTRACT.address
  //   );

  //   try {
  //     const amount = await contract.methods
  //       .spinBalance(library.utils.toChecksumAddress(account))
  //       .call();
  //     setGeoSpinsAmount(amount);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const onCaptchaChange = () => {
    const value = captcha.current.getValue() ? true : false;
    setCaptchaValidated(value);
  };

  return (
    <>
      <BuyGeosModal
        displayModal={displayBuyGEOTokens}
        setDisplayModal={setDisplayBuyGEOTokens}
      />
      <DownloadsModal
        displayModal={displayDownloads}
        setDisplayModal={setDisplayDownloads}
      />
      <Header
        geoTokensAmount={geoTokensAmount}
        NFTsAmount={NFTsAmount}
        // geoSpinsAmount={geoSpinsAmount}
        setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
        setDisplayDownloads={setDisplayDownloads}
        onClickConnectWallet={() => connectInjected()}
      />
      <Layout>
        <Container fluid className="staking">
          <Row className="title">
            <p>
              <span className="purple">Geo$</span>
              Vesting
            </p>
          </Row>
          <Row className="justify-content-center">
            <Col xs={10} className="stak-content text-center p-3">
              <h3>
                TOKEN ADDRESS:
                <br />
                <span>{tokenAddress}</span>
              </h3>
              {!active ? (
                <div className="wallet">
                  <ReCAPTCHA
                    ref={captcha}
                    sitekey={REACT_APP_SITE_KEY_CAPTCHA}
                    onChange={onCaptchaChange}
                  />
                  <p>Please connect to your wallet!</p>
                  <button
                    className="align-items-center"
                    onClick={() => connectInjected()}
                    disabled={!captchaValidated}
                  >
                    <i>
                      <FaWallet />
                    </i>
                    <span className="ml-1">Connect Wallet</span>
                  </button>
                </div>
              ) : (
                <div className="wallet">
                  {claimable > 0 ? (
                    <button
                      className="align-items-center"
                      onClick={() => claimVested()}
                    >
                      <i className="ml-2 mr-1">
                        <FaWallet />
                      </i>
                      <span>Claim Tokens</span>
                    </button>
                  ) : (
                    <button className="align-items-center" disabled>
                      <i className="ml-2 mr-1">
                        <FaWallet />
                      </i>
                      <span>No pending tokens to claim</span>
                    </button>
                  )}
                </div>
              )}
            </Col>
          </Row>

          <Row className="boxes">
            <Col xs={12} md={4} className="box">
              <h2>Total Vestments:</h2>
              <h1>GEO$ {totalVestment}</h1>
            </Col>

            <Col xs={12} md={4} className="box">
              <h2>Amount Available To Withdraw</h2>
              <h4>{claimable}</h4>
            </Col>

            <Col xs={12} md={5} className="box">
              <h2>Next claim in:</h2>
              <Countdown target={nClaimTime} />
            </Col>
          </Row>
        </Container>
      </Layout>
      <Footer />
    </>
  );
}

export default Vesting;
